import { ContentProps } from './Types'
import Styles from './Content.module.scss'

const Content = ({ children, padding }: ContentProps) => {
  return (
    <div className={Styles.content} style={{ padding }}>
      {children}
    </div>
  )
}

export { Content }
